var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationSpeedTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5326 13.5662H8.66845L0.949219 21.2854V32.1495L8.66845 39.8687H19.5326L27.2518 32.1495V21.2854L19.5326 13.5662Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1044 25.8121H25.3916C25.1534 23.5249 24.248 21.4284 22.8662 19.7606L21.2461 21.3807C22.2467 22.6672 22.9138 24.1444 23.1044 25.8121Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6775 19.8082L21.2976 18.1881C19.6299 16.8063 17.5333 15.901 15.2461 15.6627V17.9499C16.8662 18.1405 18.391 18.8076 19.6775 19.8082Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9538 17.9499V15.6627C10.6667 15.901 8.57008 16.8063 6.90234 18.1881L8.52243 19.8082C9.76132 18.8076 11.2861 18.1405 12.9538 17.9499Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28324 19.7606C3.9014 21.476 2.99606 23.5726 2.75781 25.8121H5.04499C5.23559 24.1444 5.90268 22.6196 6.90333 21.3807L5.28324 19.7606Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6722 21.6021L15.3171 30.9741H12.9157L12.5607 21.6021H15.6722ZM12.4766 33.8801C12.4766 33.4627 12.6261 33.1108 12.9251 32.8242C13.2241 32.5377 13.6196 32.3944 14.1118 32.3944C14.5977 32.3944 14.987 32.5377 15.2798 32.8242C15.5788 33.1108 15.7283 33.4627 15.7283 33.8801C15.7283 34.3037 15.5788 34.6588 15.2798 34.9453C14.987 35.2256 14.5977 35.3658 14.1118 35.3658C13.6196 35.3658 13.2241 35.2256 12.9251 34.9453C12.6261 34.6588 12.4766 34.3037 12.4766 33.8801Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.3918,
    cy: 13.6432,
    r: 13.1808,
    fill: "#D52924"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2643 5.64439V19.7172H24.9429V8.39923L21.5042 9.56473V7.64791L26.9849 5.64439H27.2643Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSpeedTravel);
export default __webpack_public_path__ + "static/media/notification-speed-travel.2aaf21cf31a722f8ce799de6be6feb56.svg";
export { ForwardRef as ReactComponent };